var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-export';
                    var viewUrl = 'sprite.svg#view-icon-export';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-export#icon-export';
                            viewUrl = 'sprite.svg?icon-export#view-icon-export';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 16 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };